import React, { Component } from 'react';

import ParkinglocationModel from './ParkinglocationModel';

import { Select } from 'antd';
const Option = Select.Option;

class WeekDaysSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {            
    ParkinglocationModel.getAll(true)
    .then(data => {     
      var children = [];   
      data.map((child, key) => {
      return children.push(<Option key={child.id}>{child.Code + ' - ' + child.Name}</Option>);
      });
      this.setState({
        children: children
      });
    });
  }

  render() {    
    return (    
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte den v týdnu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
        onChange={(value) => { this.props.onChange(value) }}        
        {...this.props}>
          <Option key={1}>Pondělí</Option>
          <Option key={2}>Úterý</Option>
          <Option key={3}>Středa</Option>
          <Option key={4}>Čtvrtek</Option>
          <Option key={5}>Pátek</Option>
          <Option key={6}>Sobota</Option>
          <Option key={7}>Neděle</Option>
      </Select>
    );
  }
}

export default WeekDaysSelect;


// WEBPACK FOOTER //
// ./src/components/WeekDaysSelect.js